var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import baseGetFetchWrapper from 'syf-api/api/getFetchWrapper';
import { getStaticIdFromSeed, staticTrackingId } from './trackingId';
var getFetchWrapper = function (config, accountId) {
    var fetchWrapper = baseGetFetchWrapper(config);
    return function (url, init) {
        var newInit = __assign(__assign({}, init), { headers: __assign({ 'x-syf-request-trackingid': getStaticIdFromSeed(staticTrackingId, accountId) }, init.headers) });
        return fetchWrapper(url, newInit);
    };
};
export default getFetchWrapper;
//# sourceMappingURL=getFetchWrapperWithTrackingId.js.map